import { Box, Tab, LinearProgress } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import "../assets/css/accountmetrics.scss";
import ProgramObjectives from "../components/Accountmetrics/ProgramObjectivesNew";
import AdvancedInsights from "../components/Accountmetrics/AdvancedInsights";
import TradingJournal from "../components/Accountmetrics/TradingJournal";
import AccInfo from "../components/Accountmetrics/AccInfo";
import Loader from "../reusableComponents/Loader";
import {
  fetchTraderJournal,
  fetchPerformanceChart,
  fetchAccountDetails,
  fetchAccountInsights,
  removeDashboard,
} from "../store/reducers/dashboardReducer";
import { LoadUser } from "../store/reducers/userProfileReducer";

const AccountMetric = () => {
  const [value, setValue] = useState("1");
  const [CurrentAcc, setCurrentAcc] = useState(false);
  const [CurrentPltform, setCurrentPltform] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.dashboard.loading);
  const [refreshData, setRefreshData] = useState(false);

  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  const performance_chart = useSelector(
    (state) => state.dashboard.SavePerformance
  );
  const TradeJournalNew = useSelector((state) => state.dashboard.TradeJournal);

  const { AccDetails, accountInsights } = useSelector(
    (state) => state.dashboard
  );

  
  let interval = useRef(null);
  useEffect(() => {
    if (CurrentAcc) {
      dispatch(LoadUser());
      dispatch(fetchAccountDetails(CurrentAcc, CurrentPltform));
      dispatch(fetchPerformanceChart(CurrentAcc, CurrentPltform));
      dispatch(fetchTraderJournal(CurrentAcc, CurrentPltform));
      dispatch(fetchAccountInsights(CurrentAcc, CurrentPltform));

      interval.current = setInterval(() => {
        dispatch(LoadUser());
        dispatch(fetchTraderJournal(CurrentAcc, CurrentPltform));
        dispatch(fetchAccountDetails(CurrentAcc, CurrentPltform));
        dispatch(fetchPerformanceChart(CurrentAcc, CurrentPltform));
        dispatch(fetchAccountInsights(CurrentAcc, CurrentPltform));
      }, 30 * 1000);
    }
    return () => {
      dispatch(removeDashboard());
      clearInterval(interval.current);
    };
  }, [dispatch, CurrentAcc, CurrentPltform]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const user_profile = useSelector((state) => state.user);
  useEffect(() => {
    if (Object.keys(user_profile).length) {
      if (user_profile.current_account) {
        setCurrentAcc(user_profile.current_account);
        setCurrentPltform(user_profile.current_platform)
      }
    }
  }, [user_profile]);

  const [profileActive, setProfileActive] = useState(1);
  const [mainTabination, setMainTabination] = useState(1);

  return (
    <div
      className="AccountMetricsContainer PageContainer"
      style={{ position: "relative" }}
    >
      {/* <Loader open={open} /> */}
      {loading ? <LinearProgress /> : false}

      <div className="newTabination">
        <div
          onClick={() => {
            setMainTabination(1);
          }}
          className={
            "newTabination-item " + (mainTabination === 1 && " active ")
          }
        >
          <div className="svg-con">
            <svg
              width="22"
              height="20"
              viewBox="0 0 22 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V4C1.69779e-06 3.45 0.196002 2.979 0.588002 2.587C0.980002 2.195 1.45067 1.99933 2 2H10V4H2V18H16V12H18V18C18 18.55 17.804 19.021 17.412 19.413C17.02 19.805 16.5493 20.0007 16 20H2ZM4 16H6V9H4V16ZM8 16H10V6H8V16ZM12 16H14V12H12V16ZM17 10C16.5 10 16.0083 9.925 15.525 9.775C15.0417 9.625 14.5917 9.40833 14.175 9.125L13.8 9.475C13.6 9.65833 13.3623 9.75 13.087 9.75C12.8117 9.75 12.5827 9.65833 12.4 9.475C12.2167 9.29167 12.125 9.05833 12.125 8.775C12.125 8.49167 12.2167 8.25833 12.4 8.075L12.8 7.675C12.5333 7.275 12.3333 6.85 12.2 6.4C12.0667 5.95 12 5.48333 12 5C12 3.61667 12.4877 2.43767 13.463 1.463C14.4383 0.488333 15.6173 0.000666667 17 0H22V5C22 6.38333 21.5123 7.56267 20.537 8.538C19.5617 9.51333 18.3827 10.0007 17 10ZM17 8C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5V2H17C16.1667 2 15.4583 2.29167 14.875 2.875C14.2917 3.45833 14 4.16667 14 5C14 5.21667 14.021 5.425 14.063 5.625C14.105 5.825 14.1673 6.025 14.25 6.225L16.85 3.625C17.0333 3.44167 17.2667 3.35 17.55 3.35C17.8333 3.35 18.0667 3.44167 18.25 3.625C18.45 3.825 18.55 4.06267 18.55 4.338C18.55 4.61333 18.45 4.85067 18.25 5.05L15.65 7.65C15.8667 7.75 16.0877 7.83333 16.313 7.9C16.5383 7.96667 16.7673 8 17 8Z"
                fill="white"
              />
            </svg>
          </div>
          Program Objectives
        </div>

        <>
          <div
            onClick={() => {
              setMainTabination(2);
            }}
            className={
              "newTabination-item " + (mainTabination === 2 && " active ")
            }
          >
            <div className="svg-con">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 8C19.55 8 18.74 9.44 19.07 10.51L15.52 14.07C15.22 13.98 14.78 13.98 14.48 14.07L11.93 11.52C12.27 10.45 11.46 9 10 9C8.55 9 7.73 10.44 8.07 11.52L3.51 16.07C2.44 15.74 1 16.55 1 18C1 19.1 1.9 20 3 20C4.45 20 5.26 18.56 4.93 17.49L9.48 12.93C9.78 13.02 10.22 13.02 10.52 12.93L13.07 15.48C12.73 16.55 13.54 18 15 18C16.45 18 17.27 16.56 16.93 15.48L20.49 11.93C21.56 12.26 23 11.45 23 10C23 8.9 22.1 8 21 8Z"
                  fill="white"
                />
                <path
                  d="M15 9L15.94 6.93L18 6L15.94 5.07L15 3L14.08 5.07L12 6L14.08 6.93L15 9ZM3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z"
                  fill="white"
                />
              </svg>
            </div>
            Advanced Insights
          </div>
        </>

        <>
          <div
            onClick={() => {
              setMainTabination(3);
            }}
            className={
              "newTabination-item " + (mainTabination === 3 && " active ")
            }
          >
            <div className="svg-con">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="path-1-outside-1_220_9799"
                  maskUnits="userSpaceOnUse"
                  x="2"
                  y="1"
                  width="21"
                  height="21"
                  fill="black"
                >
                  <rect fill="white" x="2" y="1" width="21" height="21" />
                  <path d="M19 4C19 4.55228 19.4477 5 20 5C20.5523 5 21 4.55228 21 4C21 3.44772 20.5523 3 20 3C19.4477 3 19 3.44772 19 4Z" />
                </mask>
                <path
                  d="M15 3.75C15.4142 3.75 15.75 3.41421 15.75 3C15.75 2.58579 15.4142 2.25 15 2.25V3.75ZM21.75 9C21.75 8.58579 21.4142 8.25 21 8.25C20.5858 8.25 20.25 8.58579 20.25 9H21.75ZM5.06107 20.0451L4.62023 20.6518L4.62024 20.6518L5.06107 20.0451ZM3.95491 18.9389L4.56168 18.4981H4.56168L3.95491 18.9389ZM18.9389 20.0451L19.3798 20.6518H19.3798L18.9389 20.0451ZM20.0451 18.9389L20.6518 19.3798V19.3798L20.0451 18.9389ZM3.95491 5.06107L3.34815 4.62023L3.34815 4.62023L3.95491 5.06107ZM5.06107 3.95491L4.62023 3.34815L4.62023 3.34815L5.06107 3.95491ZM6.32665 14.5268C6.14423 14.8987 6.29782 15.3481 6.6697 15.5305C7.04158 15.7129 7.49093 15.5593 7.67335 15.1874L6.32665 14.5268ZM8.46033 11.8801L9.13368 12.2104L8.46033 11.8801ZM15.5397 12.1199L16.213 12.4502L15.5397 12.1199ZM17.6734 9.47316C17.8558 9.10127 17.7022 8.65192 17.3303 8.46951C16.9584 8.28709 16.5091 8.44068 16.3266 8.81256L17.6734 9.47316ZM12 12L11.3058 12.284L12 12ZM12 3.75H15V2.25H12V3.75ZM20.25 9V12H21.75V9H20.25ZM12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383L4.62024 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.68798 21.751 10.1418 21.75 12 21.75V20.25ZM2.25 12C2.25 13.8582 2.24897 15.312 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798L4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12H2.25ZM5.50191 19.4383C5.14111 19.1762 4.82382 18.8589 4.56168 18.4981L3.34815 19.3798C3.70281 19.8679 4.13209 20.2972 4.62023 20.6518L5.50191 19.4383ZM12 21.75C13.8582 21.75 15.312 21.751 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518L18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25V21.75ZM20.25 12C20.25 13.8916 20.249 15.25 20.135 16.302C20.0225 17.3399 19.8074 17.9901 19.4383 18.4981L20.6518 19.3798C21.2377 18.5734 21.5 17.6291 21.6263 16.4635C21.751 15.312 21.75 13.8582 21.75 12H20.25ZM19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798L19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383L19.3798 20.6518ZM3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69805C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191L3.34815 4.62023C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24897 8.68798 2.25 10.1418 2.25 12H3.75ZM12 2.25C10.1418 2.25 8.68798 2.24897 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62023 3.34815L5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69805 3.865C8.74999 3.75103 10.1084 3.75 12 3.75V2.25ZM4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168L4.62023 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62023L4.56168 5.50191ZM7.67335 15.1874L9.13368 12.2104L7.78698 11.5498L6.32665 14.5268L7.67335 15.1874ZM16.213 12.4502L17.6734 9.47316L16.3266 8.81256L14.8663 11.7896L16.213 12.4502ZM11.3058 12.284C12.185 14.433 15.1904 14.5348 16.213 12.4502L14.8663 11.7896C14.4137 12.7124 13.0833 12.6673 12.6942 11.716L11.3058 12.284ZM9.13368 12.2104C9.58632 11.2876 10.9167 11.3327 11.3058 12.284L12.6942 11.716C11.815 9.56698 8.80955 9.46517 7.78698 11.5498L9.13368 12.2104ZM17.5 4C17.5 5.38071 18.6193 6.5 20 6.5V3.5C20.2761 3.5 20.5 3.72386 20.5 4H17.5ZM20 6.5C21.3807 6.5 22.5 5.38071 22.5 4H19.5C19.5 3.72386 19.7239 3.5 20 3.5V6.5ZM22.5 4C22.5 2.61929 21.3807 1.5 20 1.5V4.5C19.7239 4.5 19.5 4.27614 19.5 4H22.5ZM20 1.5C18.6193 1.5 17.5 2.61929 17.5 4H20.5C20.5 4.27614 20.2761 4.5 20 4.5V1.5Z"
                  fill="white"
                  mask="url(#path-1-outside-1_220_9799)"
                />
              </svg>
            </div>
            Trading Journal
          </div>
        </>

        <>
          <div
            onClick={() => {
              setMainTabination(4);
            }}
            className={
              "newTabination-item " + (mainTabination === 4 && " active ")
            }
          >
            <div className="svg-con">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.25 6C15.25 7.79493 13.7949 9.25 12 9.25V10.75C14.6234 10.75 16.75 8.62335 16.75 6H15.25ZM12 9.25C10.2051 9.25 8.75 7.79493 8.75 6H7.25C7.25 8.62335 9.37665 10.75 12 10.75V9.25ZM8.75 6C8.75 4.20507 10.2051 2.75 12 2.75V1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM9 13.75H15V12.25H9V13.75ZM15 20.25H9V21.75H15V20.25ZM9 20.25C7.20507 20.25 5.75 18.7949 5.75 17H4.25C4.25 19.6234 6.37665 21.75 9 21.75V20.25ZM18.25 17C18.25 18.7949 16.7949 20.25 15 20.25V21.75C17.6234 21.75 19.75 19.6234 19.75 17H18.25ZM15 13.75C16.7949 13.75 18.25 15.2051 18.25 17H19.75C19.75 14.3766 17.6234 12.25 15 12.25V13.75ZM9 12.25C6.37665 12.25 4.25 14.3766 4.25 17H5.75C5.75 15.2051 7.20507 13.75 9 13.75V12.25Z"
                  fill="#E6FBFF"
                />
              </svg>
            </div>
            Account Info
          </div>
        </>
      </div>

      {mainTabination === 1 && (
        <ProgramObjectives
          PerformanceChart={performance_chart && performance_chart}
          AccountInfo={AccDetails && AccDetails}
          Statistics={
            TradeJournalNew &&
            TradeJournalNew.calculated_data &&
            TradeJournalNew.calculated_data
          }
          ProfitData={
            TradeJournalNew &&
            TradeJournalNew.profit_chart &&
            TradeJournalNew.profit_chart
          }
          Trades={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
          DrawDown={
            TradeJournalNew &&
            TradeJournalNew.drawdown_chart &&
            TradeJournalNew.drawdown_chart
          }
          refreshData={refreshData}
          setRefreshData={setRefreshData}
        />
      )}

      {mainTabination === 2 && (
        <AdvancedInsights
          AdvStats={accountInsights && accountInsights}
          data={
            TradeJournalNew &&
            TradeJournalNew.calculated_data &&
            TradeJournalNew.calculated_data
          }
          TradeJournalNew={TradeJournalNew}
          TradingHistory={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
          // TradedPairsSummary={TradedPairsSummary}
          // TradesLotsPerDay={tlPerDay}
          // LotsPerTrade={LotsPerTrade}
        />
      )}

      {mainTabination === 3 && (
        <TradingJournal
          platform={CurrentPltform}
          TradingHistory={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
        />
      )}

      {mainTabination === 4 && <AccInfo GeneralInfo={AccDetails} />}
    </div>
  );
};

export default AccountMetric;
